import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  Home, 
  Search, 
  Buy, 
  User, 
  Work
} from 'react-iconly';

// Style guide colors
const PRIMARY_BROWN = '#C97B53';
const NEUTRAL_BG = '#F9F9F9';
const NEUTRAL_WHITE = '#FFF';
const ACCENT_GRAY = '#757575';
const NEUTRAL_TEXT = '#222';

const bodyFont = {
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
};

export function BottomNavigation() {
  const location = useLocation();
  const { userRole } = useAuth();
  
  const navItems = [
    {
      path: '/fooddiscovery',
      label: 'Home',
      icon: Home,
      testPath: '/fooddiscovery'
    },
    {
      path: '/food-browsing',
      label: 'Search',
      icon: Search,
      testPath: '/food-browsing'
    },
    ...(userRole === 'creator' ? [{
      path: '/seller-hub',
      label: 'Store',
      icon: Work,
      testPath: '/seller-hub'
    }] : []),
    {
      path: '/cart',
      label: 'Cart',
      icon: Buy,
      testPath: '/cart'
    },
    {
      path: '/customer-dashboard',
      label: 'Account',
      icon: User,
      testPath: '/customer-dashboard'
    }
  ];

  const isActive = (item) => {
    // Home icon should be active for fooddiscovery page
    if (item.label === 'Home') {
      return location.pathname === '/fooddiscovery';
    }
    return location.pathname === item.testPath;
  };

  return (
    <nav 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: NEUTRAL_WHITE,
        borderTop: `1px solid ${NEUTRAL_BG}`,
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        marginBottom: '-56px', // Pull down to cover Chrome navigation
        paddingBottom: 'calc(56px + env(safe-area-inset-bottom))', // Push content up
      }}
      role="navigation"
      aria-label="Bottom navigation"
    >
              <div 
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: '8px 0',
            maxWidth: 1200,
            margin: '0 auto',
          }}
        >
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const active = isActive(item);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 44,
                minHeight: 36,
                padding: '6px',
                textDecoration: 'none',
                borderRadius: 8,
                transition: 'all 0.2s ease',
              }}
              aria-label={`${item.label} Tab`}
              aria-current={active ? 'page' : undefined}
            >
              <IconComponent 
                set={active ? "bold" : "regular"}
                size={18}
                primaryColor={active ? "#f4a261" : ACCENT_GRAY}
                secondaryColor={active ? "#e76f51" : ACCENT_GRAY}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNavigation; 